module.exports = __webpack_public_path__ + "img/img15.157329f0.svg";